import React, { useEffect, useState } from "react";
import { relations } from "../../../../utility/data";
import { Dropdown } from "primereact/dropdown";
import { FaTimes } from "react-icons/fa";

const AddLegacy = ({ onClose, handleSubmit, type, selectedGroup }) => {
  const [name, setName] = useState("");
  const [relation, setRelation] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (type === "edit" && selectedGroup) {
      setName(selectedGroup.name || "");
      setRelation(selectedGroup.relation || null);
    } else {
      setName("");
      setRelation(null);
    }
  }, [selectedGroup, type]);

  const handleFormSubmit = () => {
    if (!name.trim()) {
      setError("Group name is required");
      return;
    }
    if (!relation) {
      setError("Relation is required");
      return;
    }

    handleSubmit({
      name,
      relation,
      onClose,
      setError,
      setLoading,
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="relative bg-[rgba(44,52,79,1)] rounded-lg p-6 w-[400px]">
        <button
          onClick={onClose}
          className="absolute top-5 right-5 text-white font-bold"
        >
          <FaTimes className="cursor-pointer" />
        </button>
        <h2 className="text-xl font-bold text-white mb-4">
          {type === "edit" ? "Edit Legacy" : "Add Legacy"}
        </h2>

        <div className="mb-4">
          <label
            htmlFor="legacyName"
            className="block text-sm font-medium text-white mb-2"
          >
            Legacy Name
          </label>
          <input
            id="legacyName"
            type="text"
            className={`rounded-md p-3 w-full  border rounded-lg border-[rgb(161,147,147)] focus:none focus:outline-none bg-transparent placeholder-sky-400 ${
              error ? "border-red-500" : ""
            } ${name ? "text-white" : ""}`}
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              if (error) setError("");
            }}
            placeholder="Enter legacy name"
          />
        </div>

        <div className="mb-4">
          <label
            htmlFor="relation"
            className="block text-sm font-medium text-white mb-2"
          >
            Relation
          </label>
          <Dropdown
            value={relation}
            name="relation"
            onChange={(e) => {
              setRelation(e.value);
              if (error) setError("");
            }}
            options={relations}
            placeholder="Select relation"
            className={`rounded-lg w-full border focus:none dropdowntext bg-transparent p-0 border-[rgb(161,147,147)] focus:outline-none ${
              error ? "border-red-500" : ""
            }  ${relation ? "asset_Dropdown" : "text-gray-200"}`}
          />
        </div>

        <div className="flex justify-end gap-4">
          <button
            onClick={onClose}
            className="bg-transparent border border-gray-400 text-white px-4 py-2 rounded hover:bg-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={handleFormSubmit}
            disabled={loading}
            className={`px-4 py-2 rounded text-primary bg-secondary ${
              loading ? "bg-blue-300" : "hover:bg-blue-600"
            } transition`}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddLegacy;
